import Cover from '@/components/shared/BookPreview/Cover';
import Button from '@/components/shared/Button';
import Typography from '@/components/shared/Typography';
import { Character, Cover as CoverType, Size } from '@/services/models';
import router from 'next/router';
import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';

type Props = {
  bookKeyName: string;
  bookName: string;
  description: string;
  character: Character;
  cover: CoverType;
  spreadPageSize: Size;
  setShowCharacterBuilderModal: React.Dispatch<React.SetStateAction<boolean>>;
  setRedirect: React.Dispatch<React.SetStateAction<string>>;
};

const ExploreOurStoriesBook: React.FC<Props> = ({
  bookKeyName,
  bookName,
  description,
  character,
  cover,
  spreadPageSize,
  setShowCharacterBuilderModal,
  setRedirect
}) => {
  const { characterConfigured } = useSelector((state: RootStateOrAny) => state);

  const trackPreviewBook = (bookId: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const ReactPixel = window.ReactPixel;
    ReactPixel.trackCustom('CustomPreviewBook', { bookId });

    const gtag = (window as any).gtag;
    gtag('event', 'CustomPreviewBook', {
      event_category: 'CustomPreviewBook',
      event_label: 'CustomPreviewBook',
      value: bookId
    });
  };

  const previewNow = () => {
    if (characterConfigured) {
      router.push(`/book-details/${bookKeyName}`);
    } else {
      // setShowCharacterBuilderModal(true);
      // setRedirect(`/book-details/${bookKeyName}`);
      router.push(`/book-details/${bookKeyName}`);
      trackPreviewBook(bookKeyName);
    }
  };

  return (
    <>
      <div className="cursor-pointer" onClick={previewNow}>
        <Cover
          key="cover"
          bookName={bookKeyName}
          page={cover}
          character={character}
          side="right"
          spreadPageSize={spreadPageSize}
          showFlippedCorner={false}
        />
      </div>
      <Typography
        style={{
          fontSize: 20,
          fontFamily: 'Libre Baskerville',
          paddingTop: 16,
          paddingBottom: 16,
          width: '110%'
        }}
      >
        {bookName}
      </Typography>
      <Typography
        className="font-sans"
        style={{
          paddingBottom: 16
        }}
      >
        {description}
      </Typography>
      <div onClick={previewNow}>
        <Button className="w-full xl:w-44 xl:h-12" aria-label="Preview Now">
          <span
            style={{
              fontFamily: 'Nunito',
              fontWeight: 800,
              fontSize: 14
            }}
          >
            Read Now
          </span>
        </Button>
      </div>
    </>
  );
};

export default ExploreOurStoriesBook;
